<template>
  <b-modal id="bflowEventSource" size="lg" title="Business Flow Event" @ok="okClick">
    <div class="row">
      <div class="col-md">
        <strong>Ereigniss wählen:</strong><br/>
        <ul class="event-tree">
          <li v-for="(source,skey) in emap" :key="skey">
            <span class="esource" @click="toggle(skey)">{{ skey }}</span>
            <ul v-if="show[skey]" :id="skey" class="group-tree">
              <li v-for="(group,gkey) in source" :key="gkey">
                <span class="egroup" @click="toggle(skey + '-' + gkey)">{{ gkey }}</span>
                <ul v-if="show[skey + '-' + gkey]" class="event-tree">
                  <li v-for="(signal,ekey) in group" :key="ekey" class="esignal">
                    <span class="esignal" @click="selectEvent(skey,gkey,ekey)">{{ ekey }}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="col-md">
        <strong>Ereigniss Parameter</strong>
        <ul class="param-tree">
          <li v-for="(d1,skey) in schema" :key="skey">{{ skey }} - {{ d1 }}</li>
        </ul>
      </div>
    </div>
  </b-modal>
</template>

<script>
import bflows from '@/modules/bflows.js'

export default {
  name: 'BFlowEventSelector',
  data() {
    return {
      show: {},
      emap: {},
      schema: {},
      visible: {},
      selected: {},
    }
  },
  created: function() {
    bflows.eventmap(this.fetchEventSources.bind(this));
  },
  methods: {
    selectEvent: function(source,group,ename) {
      console.log('sel: ' + source + ' ' + group + ' ' + ename);
      this.schema = this.emap[source][group][ename];
      this.selected.source = source;
      this.selected.group  = group;
      this.selected.event  = ename;
      console.log(this.schema);
    },
    okClick: function() {
      this.$emit('selected',this.selected);
    },
    fetchEventSources: function(data) {
      console.log(data);
      this.emap = data;
    },
    toggle: function(cid) {
      console.log(cid);
      this.show[cid] = !this.show[cid];
      this.$forceUpdate();
    }
  }
}
</script>

<style>
.event-tree {
  list-style: none;
}
.event-tree li {
  margin-top: 8px;
}
.esource {
  padding: 6px 10px;
  background-color: #dde;
  border-radius: 3px;
  font-size: 18px;
  font-weight: bold;
}
.egroup {
  padding: 4px 8px;
  background-color: #ded;
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
}
.esignal {
  padding: 3px 6px;
  background-color: #eed;
  border-radius: 3px;
  font-size: 12px;
}
.group-tree {
  list-style: none;
}
</style>
